import Vue from 'vue'

export const subscription = new Vue()
